module.exports = "Use `ipfs.dag.put` to create a node for the data `{ test: 1 }`. Return the CID of your new node.\n"